import { format } from 'date-fns';
import { client } from '../apiClient';
import {
  AnomalyIncidentsResponse,
  getEmptyAnomalyIncidentsResponse,
} from '../../models/anomaly-detection/models/AnomalyIncidentsResponse';

export const ANOMALY_INCIDENTS_ENDPOINT = '/projects/anomaly-incidents';

export const getAnomalyIncidents = async (
  projectId: number,
  from: Date | null,
  to: Date | null,
  keywords: string[],
  filterChatTypes?: string[],
): Promise<AnomalyIncidentsResponse> => {
  if (!from || !to || keywords.length === 0) {
    return getEmptyAnomalyIncidentsResponse();
  }

  const formattedFrom = format(from, 'yyyy-MM-dd');
  const formattedTo = format(to, 'yyyy-MM-dd');

  const params = new URLSearchParams();
  params.set('keywords', keywords.join(','));
  if (filterChatTypes && filterChatTypes.length > 0) {
    params.set('models', filterChatTypes.join(','));
  }

  const { data } = await client(true, true).get<AnomalyIncidentsResponse>(
    `${ANOMALY_INCIDENTS_ENDPOINT}/${projectId}/${formattedFrom}/${formattedTo}?${params.toString()}`
  );

  return data;
};
